import { Card } from "primereact/card";
import { InputSwitch } from "primereact/inputswitch";
import { Skeleton } from "primereact/skeleton";
import { useBreadcrumb } from "sj-ui-toolkit/src/atlas/hooks/useBreadcrumbs";
import { AdminAppRoutes } from "sj-ui-toolkit/src/constants/routes";
import { useAspenFeatures } from "@/hooks/useAspenFeatures";

export default function AspenAssist() {
  useBreadcrumb({
    label: "Aspen Assist",
    route: AdminAppRoutes.routes.aspen.routes.assist.route,
    display: "none",
    resetTrail: true,
  });

  const { features, isLoading, viewOnly, enableAspenGlobally, toggleFeature } = useAspenFeatures();

  if (isLoading) return <Skeleton width="100%" height="20rem" />;

  return (
    <>
      <h1 className="mb-4">Aspen Assist</h1>

      <Card pt={{ content: { className: "p-0" } }} className="mb-4">
        <div className="flex items-center justify-between mb-4 pb-4 border-b border-surface-200">
          <strong>Aspen Assist</strong>
          <InputSwitch
            checked={features.assist}
            onChange={e => void toggleFeature("assist", e.value)}
            disabled={viewOnly || !enableAspenGlobally}
          />
        </div>
        <p>
          Aspen Assist is available in most of our sandbox lessons, and provides hints to users as
          they attempt to remediate the vulnerability found in the sandbox.
        </p>
        <p className="mt-2">
          To generate a relevant hint, we send the following information to our AI provider:
        </p>
        <ul className="list-disc list-inside ml-4 mt-2">
          <li>The reference solution that we have developed to fix the vulnerability</li>
          <li>The last 60 minutes of the user&apos;s code submissions for this lesson</li>
          <li>
            A prompt that tells the LLM to generate a hint for the user, without directly revealing
            the answer
          </li>
        </ul>
        <p className="mt-2">
          This data is provided in a context that does not remember or train the model on the
          submission in any way.
        </p>
      </Card>
    </>
  );
}
